<template>
  <v-switch
    data-test-id="primarySwitchInput"
    v-bind="$attrs"
    v-if="mode === EditorMode.Edit"
    density="compact"
    color="primary"
    :hide-details="hideDetails"
    :persistent-hint="true"
    style="margin-left: 0.5rem"
  >
    <template v-slot:label>
      <span class="label-override">{{ label }}</span>
    </template>

    <!-- @vue-skip -->
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </v-switch>
  <DisplayText v-else data-test-id="primarySwitchInputDisplay" :value="value" :label="label" />
</template>

<script setup lang="ts">
// STORES, IMPORTS, & COMPOSABLES
import { EditorMode } from '@/enums/EditorMode'
import type { PropType } from 'vue'

// PROPS & EMITS

// REACTIVE VARIABLES

defineProps({
  hideDetails: { type: Boolean, default: true },
  label: { type: String, default: '' },
  mode: { type: String as PropType<EditorMode>, default: EditorMode.Edit },
  value: { type: [String, Number, null] }
})

// COMPUTED PROPERTIES

// LIFECYCLE HOOKS

// FUNCTIONS
</script>

<style lang="scss" scoped>
.label-override {
  text-transform: none;
}
</style>
